<template>
    <BasePopup v-bind:isOpen="isShowPopup">
        <div v-if="winner" class="jackpotWinnerPopUpWrapper">
            <div class="jackpotWinnerPopUp">
                <div class="jackpotWinnerPopUp_header" />
                <div class="jackpotWinnerPopUp_content">
                    <span>
                        {{ i18n.t('jackpot_congratulations') }}
                    </span>
                    <I18nT
                        tag="div"
                        class="jackpotWinnerInfo"
                        keypath="jackpot_youWon"
                    >
                        <template #jackpot>
                            <span class="highlight">{{ i18n.t(`jackpot_${winner.type.toLowerCase()}Jackpot`) }}</span>
                        </template>
                        <template #amount>
                            {{ formatMoneyWithSymbolAndDecimal(winner.amount) }}
                        </template>
                    </I18nT>
                    <button
                        type="button"
                        class="claimButton"
                        v-on:click="claim()"
                    >
                        {{ i18n.t('jackpot_claimNow') }}
                    </button>
                </div>
                <div class="bgDeco">
                    <div class="ray ray-1" />
                    <div class="ray ray-2" />
                    <span
                        v-for="i in 20"
                        v-bind:key="i"
                        v-bind:class="`shiny shiny-${i}`"
                    />
                    <Vue3Lottie
                        v-if="!isJackpotEFootballInBigEventTheme"
                        class="bgDeco_coins"
                        v-bind:animationData="animationData"
                    />
                </div>
            </div>
        </div>
    </BasePopup>
</template>

<script lang="ts">
    import { storeToRefs } from 'pinia';
    import { defineComponent } from 'vue';
    import { Vue3Lottie } from 'vue3-lottie';
    import animationData from '@/assets/images/jackpot/lottie/coinSpray.json';
    import BasePopup from '@/components/common/BasePopup.vue';
    import { useJackpotWinnerPopup } from '@/libraries/composables/popup/useJackpotWinnerPopup';
    import { i18n } from '@/libraries/i18n';
    import { useAccountStore } from '@/stores/accountStore';
    import { useFeatureToggleStore } from '@/stores/featureToggleStore';

    export default defineComponent({
        name: 'JackpotWinnerPopup',
        components: { BasePopup, Vue3Lottie },
        emits: ['close'],
        setup(_, { emit }) {
            const { winner, isShowPopup } = useJackpotWinnerPopup();

            const { formatMoneyWithSymbolAndDecimal } = useAccountStore();

            function claim() {
                emit('close');
            }

            const { isJackpotEFootballInBigEventTheme } = storeToRefs(useFeatureToggleStore());

            if (isJackpotEFootballInBigEventTheme.value) {
                import('@/scss/components/jackpotWinnerPopupBigEvent.scss');
            } else {
                import('@/scss/components/jackpotWinnerPopup.scss');
            }

            return {
                winner,
                isShowPopup,
                formatMoneyWithSymbolAndDecimal,
                claim,
                i18n,
                animationData,
                isJackpotEFootballInBigEventTheme,
            };
        },
    });

</script>
